// @ts-check
import React from 'react';

import RoutedTabs from 'src/components/Tabs/Routed';
import SportPriceLadders from './SportPriceLadders/SportPriceLadders.jsx';
import MasterPriceLadder from './MasterPriceLadder/MasterPriceLadder.jsx';

class Ladders extends React.Component {
    //@ts-expect-error
    constructor(props, context) {
        super(props, context);

        this.state = {};
    }

    UNSAFE_componentWillMount() {
        const { sportsNames, onGetSports, onGetLaddersList, onGetMasterLadder } = this.props;

        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (!sportsNames.size) {
            onGetSports();
        }

        onGetLaddersList();
        onGetMasterLadder();
    }

    render() {
        //@ts-expect-error
        // eslint-disable-next-line prefer-const
        let { state, ladders, masterLadder, sportsNames } = this.props;
        //@ts-expect-error
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        sportsNames = (sportsNames.size && ladders.size) && sportsNames.filter((sport, key) => ladders.has(key)).sortBy((sport, key) => key) || sportsNames;

        return (
            <section className='ladders'>
                {/* #TODO - to remove  */}
                <RoutedTabs
                    className='tabs__horizontal tabs__customers-inner ladders-menu'
                    namespace='global'
                    parameter='tab.tab'
                    tabsPlacement='left-vertical-menu'
                >
                    <MasterPriceLadder
                        key='master'
                        label='Master ladder'
                        masterLadder={ masterLadder }
                        onGetMasterLadder={ this.props.onGetMasterLadder }
                        onCreatePrice={ this.props.onCreatePrice }
                        onSavePrice={ this.props.onSavePrice }
                        onDeletePrice={ this.props.onDeletePrice }
                    />
                    {
                        //@ts-expect-error
                        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        (sportsNames.size && ladders.size) && ladders.entrySeq().map(([sportId, ladder]) => {
                            return (
                                <SportPriceLadders
                                    key={sportId}
                                    label={sportsNames.getIn([sportId, 'name'])}
                                    ladder={ladder}
                                    sport={sportId}
                                    sportsNames={ sportsNames }
                                    onSave={ this.props.onSaveSportLadder }
                                    onCopy={ this.props.onCopySportLadder }
                                    onGetSportLadder={this.props.onGetSportLadder}
                                />
                            );
                        }).toArray() || []
                    }
                </RoutedTabs>
            </section>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default Ladders;
